import React from 'react';
import { Formik, Form, FormikHelpers } from 'formik';
import { Button, Spinner } from 'reactstrap';
import {
  FormikInput as Input,
  useToast,
  useTranslator,
  useAppContext,
} from '@front-activerse/common-components';
import { useNavigate } from 'react-router-dom';
import validationSchema from './validationSchema';

interface IActivateProductForm {
  activateProduct: (accessCode: string) => Promise<any>;
}

const ActivateProductForm: React.FC<IActivateProductForm> = ({ activateProduct }) => {
  const { t } = useTranslator();
  const { toastError, toastSuccess } = useToast();
  const navigate = useNavigate();
  const {
    consts: { APP_BRAND },
  } = useAppContext();

  const initialValues = {
    accessCode: '',
  };

  const handleSubmit = async (
    values: typeof initialValues,
    { setFieldError }: FormikHelpers<typeof initialValues>
  ) => {
    try {
      const response = await activateProduct(values.accessCode);
      const { __typename } = response.data.me.coupon.activate;

      if (__typename === 'BasicMutationSuccess') {
        toastSuccess(<p>{t('toastMessage.couponActivated')}</p>, 5000);
        if (APP_BRAND === 'dtba') {
          navigate('/');
        } else {
          navigate('/thankyou-activation');
        }
      } else if (__typename === 'ValidationException') {
        const validationMessage = response.data.me.coupon.activate.details[0].messages[0];
        setFieldError('accessCode', validationMessage);
      } else {
        toastError();
      }
    } catch (err) {
      toastError();
    }
  };
  return (
    <Formik
      onSubmit={handleSubmit}
      initialValues={initialValues}
      validationSchema={validationSchema}
    >
      {({ isValid, isSubmitting }) => (
        <Form>
          <Input
            name="accessCode"
            type="text"
            label={t('inputLabel.enterAccessCode')}
            translateErrMsg
          />
          <Button
            type="submit"
            color="primary"
            className="w-100 mt-m"
            disabled={isSubmitting || !isValid}
          >
            {isSubmitting ? (
              <>
                <Spinner />
                <span className="ms-2">{t('data-processing')}</span>
              </>
            ) : (
              t('couponActivation.activateAccess.button')
            )}
          </Button>
        </Form>
      )}
    </Formik>
  );
};

export default ActivateProductForm;
